import { LaneType } from 'common-types';

import {
  MediaAudioContentTypeEnum,
  MediaDocumentContentTypeEnum,
  MediaImageContentTypeEnum,
  MediaTypeEnum,
  MediaVideoContentTypeEnum,
} from 'constants-media';

export type ImageMediaOptions = {
  maxWidth?: number;
  maxHeight?: number;
};

export type DocumentMediaOptions = {
  maxSize?: number;
};

export type HTMLImage = HTMLImageElement & { type: string; size: number };

export type ThumbnailType = {
  uri: string;
  width: number;
  height: number;
  type: 'image/png' | 'image/jpeg' | 'image/jpg';
  size: number;
  name: string;
};

export type OptimizedMedia = {
  id: LaneType.UUID;
  type: string;
  key: string;
};

export type MediaImageFileType = {
  name?: string;
  size: number;
  type: MediaImageContentTypeEnum;
  width?: number;
  height?: number;
};

export type MediaDocumentFileType = {
  name?: string;
  size: number;
  type: MediaDocumentContentTypeEnum;
};

type MediaBaseType = {
  _id: string;
  _created: string;
  _updated: string;
  name: string;
  description?: string;
  type: MediaTypeEnum;
  inUse?: boolean;
};

export type MediaImageType = MediaBaseType & {
  file: MediaImageFileType;
  thumbnail?: MediaImageFileType;
  contentType: MediaImageContentTypeEnum;
};

export type MediaDocumentType = MediaBaseType & {
  file: MediaDocumentFileType;
  previewUrl?: string;
  thumbnail?: {};
  contentType: MediaDocumentContentTypeEnum;
};

export type MediaType = {
  contentType:
    | MediaImageContentTypeEnum
    | MediaVideoContentTypeEnum
    | MediaAudioContentTypeEnum
    | MediaDocumentContentTypeEnum;
  s3Bucket?: string;
} & (MediaDocumentType | MediaImageType);

export type MediaWithCreatedByInfo = MediaDocumentType & {
  _created: Date;
  _createdBy: { _id: string };
  _updated: Date;
  _updatedBy: { _id: string };
};

export type MediaContentType =
  | MediaImageContentTypeEnum
  | MediaVideoContentTypeEnum
  | MediaDocumentContentTypeEnum
  | MediaAudioContentTypeEnum;

export type Base64MediaPayload = {
  name: string;
  size: number;
  type: string;
  fileBase64: string;
  // Pre-formatted EXIF DateTimeOriginal string ("YYYY:MM:DD HH:mm:ss"),
  // not a generic date value — the server writes it into EXIF as-is.
  dateTaken?: string;
};

export function isBase64MediaPayload(
  media: unknown
): media is Base64MediaPayload {
  return (
    typeof media === 'object' &&
    media !== null &&
    'fileBase64' in media
  );
}
